import ApiService from "./ApiService";
import authService from "../AuthService";

class ProfileApiService extends ApiService {
  /**
   *
   * @returns {Promise}
   */
  async me() {
    try {
      const { data } = await this.axios.get("auth/me");
      authService.updateUserData(data);
      return data;
    } catch (err) {
      return this.throwFetchError(err);
    }
  }

  /**
   *
   * @returns {Promise}
   */
  async managedProviders() {
    if (authService.privileged)
      try {
        const res = await this.axios.get(`admins/providers`);
        return res.data;
      } catch (err) {
        return this.throwFetchError(err);
      }

    try {
      const res = await this.axios.get(
        `providers/employees/${authService.id}/shops`
      );
      return res.data;
    } catch (err) {
      return this.throwFetchError(err);
    }
  }
}

const profileApiService = new ProfileApiService();
export default profileApiService;
